import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase-config";
import { db } from "../../firebase-config";
import { app } from "../../firebase-config";
import { async } from '@firebase/util';
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";
import Cookies from 'universal-cookie';
import Modal from 'react-modal';
import DatePicker from "react-datepicker";
import Moment from 'moment';
import Wait from '../../resources/wait.gif';
import { Alert } from 'react-bootstrap';
import { modalStyle } from '../utils/shared';
const axios = require('axios').default;
const header = { "Access-Control-Allow-Origin": "*", 'content-type': 'application/x-www-form-urlencoded' }

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '900px',
    height: '650px',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

Modal.setAppElement(document.getElementById('root'));
// export default class Login extends Component {
const ProgramsModule = (props) => {
  // console.log(props);
  const cookies = new Cookies();
  const programsCollectionRef = collection(db, "programs");
  const [programs, setPrograms] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [isLoadingModal, setLoadingModal] = useState(false);
  const [action, setAction] = useState("");
  const [uid, setUid] = useState("");


  const [programName, setProgramName] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [price, setPrice] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [isActive, setIsActive] = useState(false);
  const [product_id, setProduct_id] = useState("");
  const [price_id, setPrice_id] = useState("");

  const playersCollectionRef = collection(db, "players");

  //ERROR
  const [error, SetError] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");

  useEffect(() => {
    // cookies.set('player', "", { path: '/' });
    getPrograms();
  }, [])

  useEffect(() => {
    if (isLoading) {
      document.getElementById("data").style.display = "none";
      document.getElementById("loader").style.display = "block";
    } else {
      document.getElementById("data").style.display = "block";
      document.getElementById("loader").style.display = "none";
    }
  }, [isLoading]);

  const getPrograms = async () => {
    const q = query(programsCollectionRef, where("club_id", "==", props.userData.club_id));
    const data = await getDocs(q);
    setPrograms(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
    setLoading(false);
  }

  var rowCounter = 0;

  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  function openModal() {
    setAction("Add New Program");
    setIsOpen(true);
    setUid("");
    setProgramName("");
    setPrice("");
    setMinAge("");
    setMaxAge("");
    setStartDate("");
    setEndDate("");
    setIsActive("");
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#000000';
  }
  function closeModal() {
    setIsOpen(false);
  }

  const saveProgramSt = async () => {
    setLoadingModal(true);
    var body = {
      'name': programName,
      'price': price
    };
    axios.post(process.env.REACT_APP_BACKEND+'createProduct', {
      body, header
    })
      .then(function (response) {
        if (response.data.result == "0") {
          SetError(true);
          SetErrorMessage(response.data.message);
          setLoadingModal(false);
          return;
        }
        console.log(response);
        saveProgram(response.data.price_id, response.data.product_id);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const saveProgram = async (price_id_add, product_id_add) => {
    var date = new Date();
    await addDoc(programsCollectionRef, {
      club_id: props.userData.club_id,
      programName: programName,
      minAge, minAge,
      maxAge: maxAge,
      price: price,
      startDate, startDate,
      endDate: endDate,
      date: date,
      by: props.userData.name,
      status: "Active",
      price_id: price_id_add,
      product_id: product_id_add
    }).then((res) => {
      setLoadingModal(false);
      setIsOpen(false);
      getPrograms();
    });
  }

  const updateProgramSt = async () => {
    setLoadingModal(true);

    var body = {
      "product_id": product_id,
      "price_id": price_id,
      'name': programName,
      'price': price,
    };
    axios.post(process.env.REACT_APP_BACKEND+'updateProduct', {
      body, header
    })
      .then(function (response) {
        if (response.data.result == "0") {
          SetError(true);
          SetErrorMessage(response.data.message);
          setLoadingModal(false);
          return;
        }
        updateProgram(response.data.price_id, response.data.product_id);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const updateProgram = async (price_id_add, product_id_add) => {
    const userDoc = doc(db, "programs", uid);
    var date = new Date();
    const newFields = {
      programName: programName,
      minAge, minAge,
      maxAge: maxAge,
      price: price,
      startDate, startDate,
      endDate: endDate,
      modified: date,
      by: props.userData.name,
      status: isActive,
      product_id: product_id_add,
      price_id: price_id_add
    };
    await updateDoc(userDoc, newFields).then(async () => {
      var active = "1";
      var program_name = programName;
      if (isActive == 'Inactive') {
        active = "0";
        program_name = "";
      }
      const q = query(playersCollectionRef, where("program_id", "==", uid));
      const data = await getDocs(q);
      data.forEach(async (player) => {
        const userDoc = doc(db, "players", player.id);
        const newFields = {
          active_program: active,
          program_name: program_name,
        };
        await updateDoc(userDoc, newFields);
      });
    }).then(() => {
      setLoadingModal(false);
      setIsOpen(false);
      getPrograms();
    });


  }

  const deleteProgramSt = async () => {
    setLoadingModal(true);
    var body = {
      "product_id": product_id,
    };
    axios.post(process.env.REACT_APP_BACKEND+'deactivateProduct', {
      body, header
    })
      .then(function (response) {
        if (response.data.result == "0") {
          SetError(true);
          SetErrorMessage(response.data.message);
          setLoadingModal(false);
          return;
        }
        deleteProgram();
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const deleteProgram = async () => {
    setLoadingModal(true);
    const userDoc = doc(db, "programs", uid);
    await deleteDoc(userDoc).then(() => {
      setLoadingModal(false);
      setIsOpen(false);
      getPrograms();
    });
  }

  function status(status) {
    setIsActive(status);
  }

  return (
    <>
      <h2>Registered Programs</h2>
      <div className='row'>
        <div className='col-lg-12' style={{ display: "flex" }}>
          <button className='btn btn-primary btn-sm' style={{ marginLeft: "0px" }} onClick={openModal}>Add New Program</button><br></br>
        </div>
      </div>
      <div id="data" style={{ overflowX: "scroll" }}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Program Names</th>
              <th>Price (US Dollars)</th>
              <th>Min Age</th>
              <th>Max Age</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Date Recorded</th>
              <th>Modified</th>
              <th>By</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {programs.map((program) => {
              rowCounter++;
              return (
                <tr key={program.id}>
                  <td>{rowCounter}</td>
                  <td>{program.programName}</td>
                  <td>${program.price}</td>
                  <td>{program.minAge}</td>
                  <td>{program.maxAge}</td>
                  <td>{Moment(program.startDate.toDate()).format('MM/DD/YYYY')}</td>
                  <td>{Moment(program.endDate.toDate()).format('MM/DD/YYYY')}</td>
                  <td>{program.date ? Moment(program.date.toDate()).format('MM/DD/YYYY hh:mm a') : ""}</td>
                  <td>{program.modified ? Moment(program.modified.toDate()).format('MM/DD/YYYY hh:mm a') : ""}</td>
                  <td>{program.by}</td>
                  <td>{program.status}</td>
                  <td>
                    <button className='btn btn-primary btn-sm' onClick={() => {
                      setAction("Modify Program");
                      setIsOpen(true);
                      setUid(program.id);
                      setProgramName(program.programName);
                      setPrice(program.price);
                      setMinAge(program.minAge);
                      setMaxAge(program.maxAge);
                      setStartDate(program.startDate.toDate());
                      setEndDate(program.endDate.toDate());
                      setIsActive(program.status);
                      setProduct_id(program.product_id);
                      setPrice_id(program.price_id);
                    }}>Modify</button>
                    <button className='btn btn-danger btn-sm' onClick={() => {
                      setAction("Delete Program");
                      setIsOpen(true);
                      setUid(program.id);
                      setProgramName(program.programName);
                      setPrice(program.price);
                      setMinAge(program.minAge);
                      setMaxAge(program.maxAge);
                      setStartDate(program.startDate.toDate());
                      setEndDate(program.endDate.toDate());
                      setIsActive(program.status);
                      setProduct_id(program.product_id);
                      setPrice_id(program.price_id);
                    }}>Delete</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <div className="loader-container" id="loader">
        <div className="loader"></div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={modalStyle}
        contentLabel="Example Modal"
        closeTimeoutMS={500}
      >
        <h2 ref={(_subtitle) => (subtitle = _subtitle)}>{action}</h2>

        <label>Program Name</label>
        <input type="text" id="programname" className='form-control' value={programName} readOnly={action == "Delete Program"}
          onChange={(event) => { setProgramName(event.target.value) }}></input>
        <label>Minimun Age</label>
        <input type="number" id="minage" className='form-control' value={minAge} readOnly={action == "Delete Program"}
          onChange={(event) => { setMinAge(event.target.value) }}></input>
        <label>Maximun Age</label>
        <input type="number" id="maxage" className='form-control' value={maxAge} readOnly={action == "Delete Program"}
          onChange={(event) => { setMaxAge(event.target.value) }}></input>
        <label>Price (US Dollars)</label>
        <input type="number" id="maxage" className='form-control' value={price} readOnly={action == "Delete Program"}
          onChange={(event) => { setPrice(event.target.value) }}></input>
        <label>Start Date</label><br></br>
        <DatePicker className='form-control' showYearDropdown showMonthDropdown readOnly={action == "Delete Program"}
          selected={startDate} onChange={(date) => setStartDate(date)}
        /><br></br>
        <label>End Date</label><br></br>
        <DatePicker className='form-control' showYearDropdown showMonthDropdown readOnly={action == "Delete Program"}
          selected={endDate} onChange={(date) => setEndDate(date)}
        /><br></br>
        <label>Status</label><br></br>
        <label for="active_yes">Active</label>
        <input type="radio" name="status" id="active_yes" onChange={() => status("Active")} checked={isActive == "Active" ? true : false}
          disabled={action == "Delete Program"}></input>
        <label for="active_no">Inactive</label>
        <input type="radio" name='status' id="active_no" onChange={() => status("Inactive")} checked={isActive != "Active" ? true : false}
          disabled={action == "Delete Program"}></input>
        <span style={{ color: "red" }} id="error_parenttext2"></span><br></br>
        <br></br>
        <button className='btn btn-danger btn-sm' onClick={closeModal}>Cancel</button>
        <button className={action == "Delete Program" ? 'btn btn-danger pull-right btn-sm' : 'btn btn-success pull-right btn-sm'} onClick={action == "Add New Program" ? saveProgramSt : action == "Modify Program" ? updateProgramSt : deleteProgramSt}>{
          action == "Add New Program" ? "Save" : action == "Modify Program" ? "Update" : "Delete"
        }</button>
        {isLoadingModal ? <div><img src={Wait} alt="Ball" width="25px" />Processing, please wait...</div> : ""}
        {error && (
          <Alert key={"danger"} variant={"danger"}>
            {errorMessage}
          </Alert>
        )}
      </Modal>
    </>
  )
}

export default ProgramsModule;